export default __webpack_public_path__ + "static/media/sunflowerseed.99237c99.jpeg";